export const defaultSelectStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected ? "#2048E6" : "#0D1118",
    backgroundColor: state.isSelected ? "transparent" : "transparent",
    border: state.isFocused ? "none" : "none",
  }),
  control: (provided: any) => ({
    ...provided,
    minHeight: 1,
  }),
}
